import { tasksRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { DeleteTaskDocumentJson } from '../types';

export const useDeleteDocument = () =>
  useMutation<unknown, unknown, DeleteTaskDocumentJson>((document) =>
    tasksRepo.deleteDocument(document),
  );
